
(function () {
  'use strict';

  /* ── Wait for DOM ───────────────────────────────────── */
  function init() {

    /* ── 1. Kill Dawn's hover listeners ────────────────
       Dawn's <header-menu> web component attaches
       mouseenter/mouseleave on the <details> to open it.
       We replace the entire connectedCallback so it does
       nothing on hover.                                  */
    if (window.customElements && customElements.get('header-menu')) {
      // Already defined — patch the prototype directly
      patchHeaderMenu();
    } else {
      // Wait until it's defined (Dawn registers it async)
      document.addEventListener('DOMContentLoaded', patchHeaderMenu);
      window.addEventListener('load', patchHeaderMenu); // fallback
    }

    /* ── 2. Attach click logic ────────────────────────── */
    document.addEventListener('DOMContentLoaded', attachClickLogic);
    if (document.readyState !== 'loading') attachClickLogic();
  }

  /* ─────────────────────────────────────────────────────
     Patch <header-menu> to remove hover open/close
  ───────────────────────────────────────────────────── */
  function patchHeaderMenu() {
    var HeaderMenu = customElements.get('header-menu');
    if (!HeaderMenu) return;

    var proto = HeaderMenu.prototype;

    // Store originals in case something else needs them
    proto._originalConnectedCallback = proto.connectedCallback;

    proto.connectedCallback = function () {
      // DO NOT call original — it wires up the hover listeners.
      // We only want click behaviour (handled below).
      this._details = this.querySelector('details');
      this._summary = this.querySelector('summary');
    };

    // Also null out any hover handlers already attached on existing elements
    document.querySelectorAll('header-menu').forEach(function (el) {
      var details = el.querySelector('details');
      if (!details) return;
      // Clone + replace to strip all existing listeners
      var clone = details.cloneNode(true);
      details.parentNode.replaceChild(clone, details);
    });
  }

  /* ─────────────────────────────────────────────────────
     Click logic for all header <details> menus
  ───────────────────────────────────────────────────── */
  function attachClickLogic() {
    var header = document.querySelector('.header__inline-menu, header, #shopify-section-header');
    if (!header) return;

    /* Top-level <details> (Catalog, Shop Your Vehicle) */
    var topDetails = header.querySelectorAll(':scope header-menu > details, :scope .header__menu > details');

    /* Fallback: grab all direct details inside the nav ul */
    if (!topDetails.length) {
      topDetails = header.querySelectorAll('ul.list-menu > li > header-menu > details');
    }

    topDetails.forEach(function (det) {
      var summary = det.querySelector(':scope > summary');
      if (!summary) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var isOpen = det.hasAttribute('open');

        // Close all other top-level menus first
        topDetails.forEach(function (other) {
          if (other !== det) closeDetails(other);
        });

        // Toggle this one
        if (isOpen) {
          closeDetails(det);
        } else {
          openDetails(det);
        }
      });
    });

    /* Nested <details> inside "Shop Your Vehicle"
       (the brand sub-menus: Audi, BMW, etc.)          */
    header.querySelectorAll('ul.list-menu--disclosure details').forEach(function (subDet) {
      var summary = subDet.querySelector(':scope > summary');
      if (!summary) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var isOpen = subDet.hasAttribute('open');

        // Close siblings
        var parent = subDet.closest('ul');
        if (parent) {
          parent.querySelectorAll(':scope > li > details').forEach(function (sib) {
            if (sib !== subDet) closeDetails(sib);
          });
        }

        if (isOpen) {
          closeDetails(subDet);
        } else {
          openDetails(subDet);
        }
      });
    });

    /* ── Close on outside click ── */
    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) {
        header.querySelectorAll('details[open]').forEach(closeDetails);
      }
    });

    /* ── Close on Escape ── */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        header.querySelectorAll('details[open]').forEach(closeDetails);
      }
    });
  }

  /* ─────────────────────────────────────────────────────
     Helpers
  ───────────────────────────────────────────────────── */
  function openDetails(det) {
    det.setAttribute('open', '');
    var summary = det.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  function closeDetails(det) {
    det.removeAttribute('open');
    var summary = det.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
    // Also close any nested open details inside it
    det.querySelectorAll('details[open]').forEach(function (child) {
      child.removeAttribute('open');
      var cs = child.querySelector('summary');
      if (cs) cs.setAttribute('aria-expanded', 'false');
    });
  }

  init();
})();
